import { format, formatDate } from './filter'
export const SO_FAR = new Date(2050, 11, 31)

export const zeroUnit = (val, unit = '') => {
	if (val === 0 || val) {
		return val + unit
	} else {
		return
	}
}

export const soFarDate = date => {
	if (date) {
		if (date < SO_FAR) {
			return formatDate(date)
		} else {
			return '至今'
		}
	} else {
		return ''
	}
}

export function ageCalc(birthday) {
	let birthDate = birthday instanceof Date ? birthday : new Date(birthday)
	let today = new Date()
	let age = today.getFullYear() - birthDate.getFullYear()

	if (
		today.getMonth() < birthDate.getMonth() ||
		(today.getMonth() === birthDate.getMonth() &&
			today.getDate() < birthDate.getDate())
	) {
		age--
	}
	return age
}

export function timePeriod(start, end, pattern = 'YYYY-MM') {
	if (!start && !end) {
		return
	} else if (end >= SO_FAR) {
		return format(start, pattern) + '-至今'
	} else if (!start) {
		return '至' + format(end, pattern)
	} else {
		return format(start, pattern) + '至' + format(end, pattern)
	}
}

export function getCheckboxSheetValue(map, arr, placeholder = '') {
	if (!arr || !arr.length) {
		return placeholder
	}
	return arr
		.map(item => {
			return map[item]
		})
		.join('、')
}

// 获取险种及二级险种
export function getInsuranceType(setting, order) {
	let insuranceType = setting.insuranceTypeMap[order.insuranceType]
	let subInsuranceType = setting.subinsuranceTypeMap[order.subInsuranceType]
	let subReturn = subInsuranceType ? '-' + subInsuranceType : ''
	return insuranceType + subReturn
}

export function getCondition(setting, selected, placeholder) {
	// 平安定制 - 级联选择的治疗情况
	const [condition, conditionDetail] = selected
	if (condition && conditionDetail) {
		const conditionDesc = setting.curetypeMap[condition]
		const detailDesc = setting.accidentaffectMap[conditionDetail]
		return `${conditionDesc} - ${detailDesc}`
	}
	return placeholder
}

export const typeMethods = {
	isSimpleVisit() {
		// 是简易探视
		return this.order.taskType === '0'
	},
	isFirstVisit() {
		// 是初次探视
		return this.order.taskType === '1'
	},
	isResurvey() {
		// 是住院复勘
		return this.order.taskType === '2'
	},
	isResurveyInHospital() {
		const injured = this.injured
		// 住院复勘在医院
		return (
			this.order.taskType === '2' &&
			injured &&
			injured.injured &&
			injured.injured.inHospital === '1'
		)
	},
	isResurveyNotInHospital() {
		const injured = this.injured
		// 住院复勘不在医院
		return (
			this.order.taskType === '2' &&
			injured &&
			injured.injured &&
			injured.injured.inHospital === '0'
		)
	},
	isNewMotion() {
		// 是伤者家中调查
		return this.order.taskType === '16'
	},
	isHomeInvestigate() {
		return this.isNewMotion
	},
	isMotion() {
		// 是活动度复勘
		return this.order.taskType === '3'
	},
	isMotionInHospital() {
		const order = this.order
		// 是活动度复勘且伤者在医院
		return order.taskType === '3' && order.locationType === '1'
	},
	isMotionAtHome() {
		const order = this.order
		// 是活动度复勘且伤者在家
		return order.taskType === '3' && order.locationType === '0'
	},
	isWholeProcess() {
		// 是全流程任务
		return this.order.orderType === '2'
	},
	isInvestigate() {
		const order = this.order
		// 是居住地调查/工作调查
		return ['4', '5'].includes(order.taskType)
	},
	isLivingInvestigate() {
		// 是居住地调查
		return this.order.taskType === '4'
	},
	isWorkInvestigate() {
		// 是工作调查
		return this.order.taskType === '5'
	},
	isOtherInvestigate() {
		// 是其他调查
		return this.order.taskType === '15'
	},
	isMediate() {
		// 是调解任务
		return ['8', '9'].includes(this.order.taskType)
	},
	isOtherMediate() {
		// 车险任务详情中发起的调解任务
		return this.order.taskType === '8'
	},
	isInHospitalMediate() {
		//住院调解
		return this.isOtherMediate
	},
	isPureMediate() {
		// 是调解任务的新建任务
		return this.order.taskType === '9'
	},
	isOutpatientMediate() {
		//门诊调解,需要收集信息的
		return this.isPureMediate
	},
	isFirstHalfMediate() {
		// 是前半段收集信息
		return this.order.hasAgreement === '0'
	},
	isLastHalfMediate() {
		// 是线下调解
		// 14 - 待调解
		// 15 - 调解中
		// 16 - 待确认
		// 031 - 待初审（调解不需初审）
		// 170 - 已完成-未调解（包括作业人员撤单）
		// 171 - 已完成-调解失败
		// 172 - 已完成-调解成功
		// taskType为9时，170不算做调解，不可直接判断大于14
		return (
			(this.order.taskType === '9' ? this.order.orderStatus !== '170' : true) &&
			this.order.hasAgreement === '1'
		)
	},
	isLawsuit() {
		return ['10', '11', '12'].includes(this.order.taskType)
	},
	isFirstInstance() {
		// 一审
		return this.order.taskType === '10'
	},
	isSecondInstance() {
		// 二审
		return ['11', '12'].includes(this.order.taskType)
	},
	isRespond() {
		// 二审应诉
		return this.order.taskType === '11'
	},
	isAppeal() {
		// 二审上诉
		return this.order.taskType === '12'
	},
	needRegister() {
		// 是否需要立案
		return this.isAppeal
	},
	needReadPaper() {
		// 是否需要阅卷
		return this.order.readPaper === '1'
	},
	isCarInsurance() {
		// 车险
		return this.order.insuranceType === '01'
	},
	isLiabilityInsurance() {
		// 责任险
		return this.order.insuranceType === '02'
	},
	isAccidentInsurance() {
		// 意外险
		return this.order.insuranceType === '03'
	},
	isConstructionAccident() {
		// 建工意外险
		return (
			this.order.insuranceType === '03' && this.order.subInsuranceType === '01'
		)
	},
	isOrganizationAccident() {
		// 团体意外险
		return (
			this.order.insuranceType === '03' && this.order.subInsuranceType === '02'
		)
	},
	isPersonalAccident() {
		// 个人意外险
		return (
			this.order.insuranceType === '03' && this.order.subInsuranceType === '03'
		)
	},
	isHealthInsurance() {
		// 健康险
		return this.order.insuranceType === '04'
	},
	isInHospital() {
		// 住院病案记录
		return this.order.subTaskType === 'S02'
	},
	isWholeProcesDepth() {
		// 整案深度调查
		return this.order.subTaskType === 'S05'
	},
	isPAIC() {
		// 平安定制
		return this.order.subTaskType === 'PAIC'
	},
}
